import React from 'react';
import PropTypes from 'prop-types';
/* Components */
import WidgetEmpty from '../empty-widget-content/empty-widget-content';
import DataGrid from './data-grid/data-grid';
/* Helpers */
import {CONTENT_TYPE} from '../widget-constants';
class GridContent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedRows: 0,
      totalRows: 0,
    };
  }

  getContentType = () => {
    if (this.props.errorMessage) {
      return CONTENT_TYPE.ERROR;
    }
    if (!this.props.dataInitialized && !this.props.dataType) {
      return CONTENT_TYPE.NOT_INITIALIZED;
    }
    if (this.props.dataFeed && !Object.keys(this.props.dataFeed).length) {
      return CONTENT_TYPE.EMPTY;
    }
    return CONTENT_TYPE.DATA;
  };

  setSelectedAndTotalRows = (selected, total) => {
    this.setState({
      selectedRows: selected,
      totalRows: total,
    });
  };

  renderContent = () => {
    switch (this.getContentType()) {
      case CONTENT_TYPE.NOT_INITIALIZED:
        return (
          <WidgetEmpty
            isEditAllowed={this.props.isEditAllowed}
            showSettingsModal={this.props.toggleSettingsModal}
          />
        );
      case CONTENT_TYPE.ERROR:
        return (
          <WidgetEmpty
            isEditAllowed={this.props.isEditAllowed}
            showSettingsModal={this.props.toggleSettingsModal}
            text={this.props.errorMessage || 'Something went wrong.'}
          />
        );
      case CONTENT_TYPE.EMPTY:
        return (
          <WidgetEmpty
            isEditAllowed={this.props.isEditAllowed}
            showSettingsModal={this.props.toggleSettingsModal}
          />
        );
      case CONTENT_TYPE.DATA:
        return (
          <>
            <div
              className="glu-content__section glu-content__separator
                        glu-content__separator--inner glu-scroll-fix"
            >
              <DataGrid
                widgetId={this.props.widgetId}
                columnConfig={this.props.columnsConfig}
                dataFeed={this.props.dataFeed}
                solutionRedirect={this.props.handleSolutionRedirect}
                setSelectedAndTotalRows={this.setSelectedAndTotalRows}
                isEditAllowed={this.props.isEditAllowed}
                filter={this.props.formData.filter.mongoQuery}
              />
              <div className="glu-grid__total-rows">
                {`${this.state.selectedRows}/${this.state.totalRows}`}
              </div>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  render() {
    return this.renderContent();
  }
}

GridContent.propTypes = {
  errorMessage: PropTypes.string,
  dataInitialized: PropTypes.bool,
  dataType: PropTypes.objectOf(PropTypes.any),
  dataFeed: PropTypes.objectOf(PropTypes.any),
  isEditAllowed: PropTypes.bool,
  toggleSettingsModal: PropTypes.func.isRequired,
  widgetId: PropTypes.string,
  columnsConfig: PropTypes.objectOf(PropTypes.any),
  formData: PropTypes.objectOf(PropTypes.any),
  handleSolutionRedirect: PropTypes.func.isRequired,
};

GridContent.defaultProps = {
  errorMessage: '',
  dataInitialized: false,
  dataType: null,
  dataFeed: null,
  isEditAllowed: false,
  widgetId: '',
  columnsConfig: {},
  formData: {},
};

export default GridContent;
